/*
    🔥 EMOJIS

    Un set curado en vez de los 3.600 del estándar Unicode. Motivo:
    una lista completa pesa cientos de KB y nadie usa el 90%.

    Si necesitás el set entero, este archivo es el único lugar a tocar:
    la forma { category, items } no cambia.
*/

export const EMOJI_SET = [

    {
        id: 'caras', label: 'Caras',
        items: ['😀', '😄', '😁', '😅', '😂', '🙂', '😉', '😊', '😍', '😘',
            '🤗', '🤔', '😐', '😴', '😎', '🥳', '😢', '😭', '😡', '🤯',
            '😱', '🤩', '🙃', '😬', '🤐', '🥺', '😌', '🤓'],
    },

    {
        id: 'gestos', label: 'Gestos',
        items: ['👍', '👎', '👌', '✌️', '🤞', '🤟', '👋', '🙌', '👏', '🙏',
            '💪', '🤝', '☝️', '👇', '👉', '👈', '✍️', '🫶'],
    },

    {
        id: 'objetos', label: 'Objetos',
        items: ['💻', '📱', '⌨️', '🖥️', '🖨️', '📷', '🎧', '📁', '📂', '📄',
            '📊', '📈', '📉', '📌', '📎', '✂️', '🔑', '🔒', '🔔', '💡',
            '🔧', '⚙️', '🧰', '📦', '🛒', '💳', '💰', '🧾'],
    },

    {
        id: 'simbolos', label: 'Símbolos',
        items: ['✅', '❌', '⚠️', 'ℹ️', '❓', '❗', '⭐', '🔥', '💯', '✨',
            '🎯', '🚀', '⏰', '📅', '🔄', '➕', '➖', '🔍', '🏆', '🎁'],
    },

    {
        id: 'naturaleza', label: 'Naturaleza',
        items: ['🌱', '🌳', '🌵', '🌻', '🌸', '🍀', '☀️', '🌙', '⭐', '☁️',
            '🌧️', '⛄', '🌊', '🔥', '🌈', '🐶', '🐱', '🐴', '🦊', '🐝'],
    },

    {
        id: 'comida', label: 'Comida',
        items: ['☕', '🍵', '🧉', '🍺', '🍷', '🥤', '🍕', '🍔', '🌮', '🥗',
            '🍜', '🍣', '🥐', '🍞', '🧀', '🍎', '🍌', '🍓', '🎂', '🍫'],
    },

];

export const EMOJI_ALL = EMOJI_SET.flatMap((cat) => cat.items);
